export enum ELocationQueryKey {
  GET_PROVINCES = 'get-provinces',
  GET_COUNTIES = 'get-counties',
  GET_CITIES = 'get-cities',
  GET_DISTRICTS = 'get-districts',
}
